import { formatNumber } from "../formatNumber";

type FormatCurrencyProps = {
	valueInCents: number;
	locale: string;
	currency: string;
	minimumFractionDigits?: number;
};

export const formatCurrency = ({ valueInCents, currency, locale, minimumFractionDigits }: FormatCurrencyProps) => {
	return formatNumber({
		value: valueInCents / 100,
		locale,
		options: {
			style: "currency",
			currency,
			currencyDisplay: "narrowSymbol",
			minimumFractionDigits,
		},
	});
};
